import { Box, Paper } from '@mui/material'
import { CustomTabs, UserTable } from 'components'
import { CustomerStatusProvider } from 'contexts/customer-status-provider'
import { useEffect, useState } from 'react'
import { createUsers } from 'services/cm-api/create-users'
import { deleteUser } from 'services/cm-api/delete-user'
import { updateUser } from 'services/cm-api/update-user'
import { useGetSelectedCustomerData } from './selected-customer.controller'
import AuditLogViewer from './widgets/audit-log-viewer'
import GeneralInformation from './widgets/general-information'
import GlobalDataTable from './widgets/global-data-table'
import LookupUsage from './widgets/lookup-usage'
import Restrictions from './widgets/restrictions'
import UserSettingsHandler from './widgets/user-settings-handler'

const SelectedCustomer = ({
  selectedCustomer,
}: {
  selectedCustomer: number | string
}) => {
  const [planNames, setPlanNames] = useState<string[]>([])
  const { data, isLoading, isSuccess } =
    useGetSelectedCustomerData(selectedCustomer)

  const {
    usersData,
    customerData,
    customerPlanData,
    customerZones,
    dashboardUsers,
    plansData,
    userSettingsData,
    userSettingsLoading,
  } = data
  const isExpired = customerData?.expires_at
    ? customerData.expires_at < new Date().toISOString()
    : false
  useEffect(() => {
    if (isSuccess)
      setPlanNames(
        plansData?.map((planObj: { name: any }) => planObj.name) ?? [],
      )
  }, [plansData, isSuccess])
  return (
    <Paper sx={{ height: '100%', minHeight: '100vh' }}>
      <Box sx={{ pb: 1 }}>
        {!isLoading && (
          <GeneralInformation
            planNames={planNames}
            customerData={customerData}
            customerPlanData={customerPlanData}
          />
        )}
      </Box>
      <CustomTabs
        items={[
          <UserTable
            isExpired={isExpired}
            key="User Table"
            customerData={customerData}
            removeUser={deleteUser}
            updateUser={updateUser}
            createNewUser={createUsers}
            users={usersData}
            maxUsers={customerPlanData?.max_users}
            showTitle={false}
          />,
          <CustomerStatusProvider
            key="Restrictions"
            id={selectedCustomer}
            users={usersData}
          >
            <Restrictions usersLength={dashboardUsers?.length ?? 0} />
          </CustomerStatusProvider>,
          <UserSettingsHandler
            customerData={customerData}
            userSettingsData={userSettingsData}
            userSettingsLoading={userSettingsLoading}
            key="User Settings"
          />,
          <GlobalDataTable
            key="Global Zone Subscriptions"
            zones={customerZones}
            showTitle={false}
          />,
          <AuditLogViewer
            key="Audit Logs"
            customerId={selectedCustomer}
            showTitle={false}
          />,
          <LookupUsage
            key={`Lookups ${selectedCustomer}`}
            customerId={selectedCustomer}
          />,
        ]}
        tabs={[
          {
            label: `Users (${dashboardUsers?.length})`,
            index: 0,
          },
          {
            label: 'Restrictions',
            index: 1,
          },
          {
            label: 'User Settings',
            index: 2,
          },
          {
            label: 'Global Data',
            index: 3,
            disabled: !customerPlanData?.rights?.global?.global_data,
          },
          {
            label: 'B.O. Audit Logs',
            index: 4,
            tooltip: 'Beneficial Owners Audit Logs',
          },
          {
            label: 'Lookups',
            index: 5,
          },
        ]}
        isLoading={isLoading}
      />
    </Paper>
  )
}

export default SelectedCustomer
